import { createUseStyles } from "react-jss";

export const useStyle = createUseStyles({
  brandContainer: {
    width: "100%"
  },
  brandTitle: {
    textAlign: "center",
    marginBottom: 24,
    "@media (max-width: 600px)": {
      marginBottom: 16
    }
  }
});
